import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpainFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8527_35995)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2.29477e-05 30.0007C-0.00700039 35.6653 1.59827 41.2149 4.62826 46.001H55.3732C58.3958 41.2118 60 35.6643 60 30.001C60 24.3377 58.3958 18.7902 55.3732 14.001H4.62826C1.5986 18.787 -0.00664634 24.3363 2.29477e-05 30.0007Z",
				fill: "#FFCE31"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.3731 14.001C52.6711 9.71389 48.9269 6.18138 44.49 3.73319C40.0531 1.285 35.0682 0.000976562 30.0007 0.000976562C24.9332 0.000976563 19.9483 1.285 15.5114 3.73319C11.0745 6.18138 7.33027 9.71389 4.62823 14.001H55.3731Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.62823 46.001C7.33033 50.288 11.0746 53.8206 15.5116 56.2687C19.9485 58.7169 24.9334 60.001 30.001 60.001C35.0685 60.001 40.0534 58.7169 44.4904 56.2687C48.9273 53.8206 52.6716 50.288 55.3737 46.001H4.62823Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4424 26.7119H7.24228V28.4761H10.4424V26.7119Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4832 39.896H7.19821V41.55H10.4832V39.896Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.94096 37.064C6.61632 37.2518 6.3949 37.443 6.43154 37.5387C6.44902 37.6289 6.55141 37.6927 6.70041 37.7907C6.9321 37.9527 7.07306 38.2418 6.96318 38.3748C7.06261 38.2961 7.14256 38.1955 7.19682 38.0809C7.25109 37.9662 7.2782 37.8407 7.27605 37.7139C7.2739 37.5871 7.24255 37.4625 7.18444 37.3498C7.12633 37.2371 7.043 37.1393 6.94096 37.064Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.002 28.458H7.66846V39.8919H10.002V28.458Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.3872 32.7352C11.6247 32.4742 10.8249 32.3391 10.019 32.3351C9.64389 32.3401 9.26976 32.3742 8.89995 32.4372C7.50454 32.6691 6.44099 33.2263 6.52506 33.6811L6.53311 33.718L6.00202 32.4952C5.90852 31.9913 7.08777 31.3722 8.63718 31.112C9.09107 31.0376 9.55045 31.0018 10.0104 31.0049C10.8128 30.9824 11.6134 31.0905 12.3811 31.325L12.3872 32.7352Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.66494 34.1711C7.01954 34.124 6.57642 33.9497 6.52425 33.6808C6.48485 33.4639 6.70433 33.2261 7.0939 33.0088C7.284 33.0341 7.47541 33.0485 7.66716 33.0518L7.66494 34.1711Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0067 33.2959C10.3114 33.3227 10.6056 33.4204 10.8658 33.5811L10.8799 33.6061C10.9512 33.7543 10.5969 34.0692 10.0034 34.4191L10.0067 33.2959Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.21593 36.3759C6.15295 36.1897 6.78447 35.821 7.6771 35.495C8.08443 35.349 8.42101 35.1958 8.83888 35.013C10.0772 34.4639 10.9918 33.8371 10.88 33.607L10.8672 33.584L11.0359 34.7677C11.1469 34.9769 10.3103 35.596 9.17018 36.1429C8.80503 36.3188 8.03421 36.6021 7.67044 36.7311C7.02005 36.9559 6.37243 37.381 6.43208 37.54L6.21593 36.3759Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.8558 26.7119H28.6562V28.4761H31.8558V26.7119Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.9012 39.896H28.6148V41.55H31.9012V39.896Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.156 37.064C32.4817 37.2518 32.7031 37.443 32.6679 37.5387C32.6496 37.6289 32.5466 37.6927 32.3976 37.7907C32.1659 37.9527 32.025 38.2418 32.134 38.3748C32.0347 38.296 31.9548 38.1954 31.9006 38.0808C31.8464 37.9662 31.8193 37.8407 31.8214 37.7139C31.8236 37.5872 31.8548 37.4626 31.9128 37.3499C31.9709 37.2372 32.054 37.1394 32.156 37.064Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.4289 28.458H29.0951V39.8919H31.4289V28.458Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.7101 32.7352C27.4735 32.4743 28.2743 32.3391 29.0811 32.3351C29.4555 32.3403 29.829 32.3744 30.1982 32.4372C31.593 32.6692 32.6571 33.2263 32.573 33.6811L32.565 33.718L33.0961 32.4952C33.1904 31.9913 32.0103 31.3723 30.4609 31.112C30.0078 31.0377 29.5491 31.0019 29.0899 31.0049C28.2868 30.9823 27.4854 31.0904 26.717 31.3251L26.7101 32.7352Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.4337 34.1711C32.0819 34.124 32.5237 33.9497 32.5753 33.6808C32.6138 33.4639 32.3949 33.2261 32.0048 33.0088C31.8145 33.0342 31.6229 33.0485 31.431 33.0518L31.4337 34.1711Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.0913 33.2959C28.7866 33.3227 28.4924 33.4204 28.2322 33.5811L28.2181 33.6061C28.1462 33.7543 28.5011 34.0692 29.0952 34.4191L29.0913 33.2959Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.8826 36.3759C32.9456 36.1897 32.3149 35.821 31.4223 35.495C31.0136 35.349 30.677 35.1958 30.2591 35.013C29.0208 34.4639 28.1048 33.8371 28.22 33.607L28.2302 33.584L28.064 34.7677C27.9511 34.9769 28.7891 35.596 29.927 36.1429C30.2921 36.3188 31.0638 36.6021 31.427 36.7311C32.0793 36.9559 32.7261 37.381 32.6673 37.54L32.8826 36.3759Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.4569 20.2783C21.3734 20.2783 25.2361 20.7162 26.6476 22.0461C25.162 25.6483 22.7241 24.1691 19.4879 24.1691C16.2432 24.1671 13.8073 25.6513 12.3142 22.0461C13.7212 20.7281 17.5498 20.2783 19.4569 20.2783Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.4448 24.2779C23.2011 23.5828 21.4553 23.4338 19.5255 23.4302C17.5973 23.4338 15.8639 23.5819 14.6195 24.2779L15.0651 25.9671C16.52 26.3565 18.022 26.5418 19.5279 26.5179C21.0339 26.5421 22.5359 26.3568 23.9908 25.9671L24.4448 24.2779Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.1173 20.0461C25.5478 19.6577 24.868 19.4637 24.1792 19.4928C23.8827 19.4917 23.5871 19.524 23.2979 19.5891C23.0587 19.3082 22.7572 19.0869 22.4175 18.9428C22.0778 18.7987 21.7092 18.7357 21.3409 18.7589C20.8876 18.7528 20.4407 18.8653 20.0443 19.0852L20.034 19.0259C20.0039 18.9114 19.9361 18.8105 19.8417 18.7392C19.7472 18.6679 19.6315 18.6305 19.5132 18.633C19.3936 18.6302 19.2765 18.6673 19.1804 18.7385C19.0842 18.8096 19.0145 18.9107 18.9821 19.0259L18.9738 19.083C18.5778 18.8642 18.1317 18.7525 17.6794 18.7589C17.3118 18.7417 16.945 18.8073 16.6062 18.951C16.2674 19.0946 15.9653 19.3126 15.7221 19.5888C15.4327 19.524 15.1369 19.4918 14.8403 19.4928C10.2229 19.4928 12.5872 22.6 12.5872 22.6L12.9651 21.9829C11.8969 20.583 12.8242 19.7331 14.8403 19.7331C15.0835 19.7322 15.3262 19.7549 15.5651 19.8008C14.8761 20.8261 16.1652 21.6879 16.1652 21.6879L16.4641 21.1979C15.7371 20.737 15.6788 18.997 17.6794 18.997C18.1256 18.9874 18.5646 19.1099 18.9413 19.3491C18.9086 19.9285 18.8393 20.5053 18.7341 21.0761L19.5132 21.8139L20.2832 21.0761C20.1789 20.5059 20.1104 19.9298 20.0782 19.3511C20.4548 19.1098 20.8949 18.9865 21.342 18.997C23.3967 18.997 23.4691 20.7259 22.5568 21.1979L22.8562 21.688C22.8562 21.688 23.9461 20.8211 23.4558 19.8008C23.6945 19.7528 23.9376 19.7301 24.1811 19.7331C26.5676 19.7681 26.7297 21.5079 26.0557 21.9829L26.4331 22.6C26.7198 22.2157 26.8471 21.7355 26.7883 21.2596C26.7294 20.7838 26.4891 20.349 26.1173 20.0461Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.8784 18.0649C18.8712 17.9374 18.9024 17.8107 18.968 17.7012C19.0336 17.5916 19.1306 17.5043 19.2464 17.4505C19.3622 17.3967 19.4915 17.3789 19.6175 17.3994C19.7435 17.4199 19.8605 17.4777 19.9533 17.5654C20.0461 17.6531 20.1104 17.7666 20.138 17.8913C20.1655 18.016 20.155 18.146 20.1078 18.2647C20.0606 18.3833 19.9789 18.4851 19.8733 18.5568C19.7676 18.6284 19.6429 18.6668 19.5152 18.6667C19.351 18.6712 19.1917 18.6103 19.0724 18.4975C18.953 18.3847 18.8832 18.2291 18.8784 18.0649Z",
				fill: "#005BBF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.3494 16.376V16.7H19.0012V17.03H19.3494V17.4834V17.98H18.9103L18.8782 18.0651L18.9293 18.3001L18.9334 18.3043H20.0991L20.1033 18.3001L20.154 18.0651L20.1207 17.98H19.6976V17.4872V17.03H20.0442V16.7H19.6976V16.376H19.3494Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.5255 26.2881C18.1383 26.3001 16.7548 26.1426 15.4058 25.8192C16.7555 25.5005 18.1388 25.3464 19.5255 25.3602C20.9145 25.3464 22.3002 25.5005 23.6523 25.8192C22.3009 26.143 20.915 26.3005 19.5255 26.2881Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.5781 43.6257C17.7403 43.6208 15.9273 43.2015 14.274 42.3989C13.7013 42.1228 13.2177 41.6912 12.8784 41.1535C12.539 40.6159 12.3576 39.9936 12.3547 39.3578V34.5767H26.773V39.3576C26.7704 39.9933 26.5893 40.6155 26.2502 41.1532C25.9112 41.691 25.4279 42.1226 24.8554 42.399C23.2117 43.2016 21.4073 43.6211 19.5781 43.6257Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.773 26.5688H19.5463V34.569H26.773V26.5688Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.5518 39.3529C19.5411 39.8138 19.4396 40.2681 19.2531 40.6897C19.0665 41.1113 18.7986 41.4919 18.4647 41.8098C18.1308 42.1277 17.7375 42.3766 17.3073 42.5422C16.877 42.7078 16.4183 42.7869 15.9574 42.775C15.0248 42.7997 14.1205 42.4532 13.4432 41.8115C12.7659 41.1698 12.371 40.2855 12.3453 39.3529V34.564H19.5532V39.3529",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9189 42.1771C14.1896 42.3451 14.4802 42.4788 14.784 42.575L14.7643 34.395H13.9183V42.1771H13.9189Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.3331 39.2882C12.3449 40.1099 12.6354 40.9032 13.1569 41.5383V34.4341H12.3433L12.3331 39.2882Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5256 42.753C15.8062 42.783 16.0892 42.783 16.3697 42.753V34.396H15.5256V42.753Z",
				fill: "#C7B500"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.113 42.575C17.4206 42.4983 17.713 42.3701 17.9779 42.1959V34.395H17.1338L17.113 42.575Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.551 26.5688H12.3461V34.569H19.551V26.5688Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7632 41.4599C19.2159 40.9477 19.4967 40.3063 19.5659 39.6261L19.5862 34.396H18.7421L18.7632 41.4599Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.781 34.564V39.3529C26.7305 40.2772 26.3278 41.1471 25.6556 41.7836C24.9833 42.4201 24.0928 42.7748 23.1671 42.7748C22.2414 42.7748 21.3508 42.4201 20.6786 41.7836C20.0064 41.1471 19.6037 40.2772 19.5532 39.3529V34.564H26.781Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.1689 27.9657C24.425 28.5681 24.4211 30.0418 23.5207 29.7277C23.6908 29.7871 23.7788 30.541 24.089 30.89C24.6162 31.488 25.1961 30.9508 25.0538 30.3101C24.8079 29.2049 24.9372 28.496 25.1587 27.4166C25.1792 27.562 25.6606 27.5359 25.8349 27.3101C25.7019 27.5989 25.677 27.999 25.7902 28.0087C25.614 28.2998 25.0652 28.7801 25.0299 29.1028C24.9603 29.7979 26.005 31.152 24.8249 31.4211C24.0424 31.6009 24.5138 32.22 24.8432 32.5299C24.8329 32.5218 24.4819 33.8049 24.6379 33.7491C23.7938 34.0538 24.0721 33.374 24.0721 33.374C24.4334 32.2216 23.4178 32.104 23.5058 31.9031C22.506 31.8498 23.6331 32.8368 22.6842 32.8368C22.4856 32.8729 22.2917 32.9314 22.1062 33.011C21.006 32.9209 21.655 31.8717 21.9727 32.0249C22.2818 32.17 22.5588 32.6708 22.6123 31.9738C22.6123 31.9738 22.1001 31.1628 23.3704 31.1711C22.9009 31.1689 22.5305 30.7238 22.3717 30.2749C21.9405 30.7016 21.3633 30.9486 20.7568 30.9658C20.7568 30.9658 20.4167 29.8917 20.7507 30.0418C20.9096 30.1412 21.1008 30.1749 21.2841 30.136C21.4674 30.097 21.6284 29.9883 21.733 29.8328C21.4933 29.5787 20.3287 29.1139 20.5027 28.4027C20.5524 28.2121 21.0929 27.9238 21.0929 27.9238C21.0652 28.0473 21.0653 28.1754 21.093 28.2988C21.1207 28.4223 21.1753 28.5381 21.253 28.638C21.3307 28.7379 21.4295 28.8193 21.5424 28.8765C21.6553 28.9337 21.7794 28.9652 21.9059 28.9688C22.7322 29.069 22.3923 28.7698 22.4633 28.5198C22.5268 28.2951 23.1448 28.602 22.9958 28.102C22.9747 28.0298 22.281 27.8678 22.508 27.6508C23.0649 27.1411 23.7383 27.4518 24.1717 27.9668",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.6071 42.614L19.3728 42.0811L19.6071 41.5479L19.8391 42.0811L19.6071 42.614Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.4542 28.2863V28.8173H14.6869V29.181H14.1881V30.2434H14.4542V32.3663H13.9224V33.462H18.0031V32.3663H17.4721V30.2434H17.7382V29.181H17.2405V28.8173H17.4721V28.2863H16.4782V28.8173H16.7099V29.181H16.2122V28.0214H16.4782V27.4893H15.448V28.0214H15.7141V29.181H15.2164V28.8173H15.448V28.2863H14.4542Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.3352 35.9583H25.0749L23.3352 37.6962V35.9583ZM25.4081 40.1102L23.4084 38.1082L25.4081 36.1101V40.1102ZM23.3352 41.3411V38.523L25.2714 40.4593L23.3352 41.3411ZM21.0604 40.4581L22.9958 38.5219V41.3402L21.0604 40.4581ZM20.9228 36.1101L22.9234 38.1082L20.9228 40.1102V36.1101ZM22.9939 35.9583L22.9958 37.6962L21.2561 35.9583H22.9939ZM25.7503 40.6083V35.6162H20.5821V40.6083L22.9958 41.7193V41.7212H23.3357V41.7193L25.7503 40.6083Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2363 34.5341C17.2363 33.0834 18.281 31.9072 19.5701 31.9072C20.8593 31.9072 21.9037 33.0834 21.9037 34.5341C21.9037 35.985 20.8593 37.1612 19.5701 37.1612C18.281 37.1612 17.2363 35.985 17.2363 34.5341Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.9272 34.5302C17.9272 33.4661 18.663 32.6021 19.5701 32.6021C20.4772 32.6021 21.2127 33.465 21.2127 34.5302C21.2127 35.5932 20.4772 36.4562 19.5701 36.4562C18.663 36.4562 17.9272 35.5932 17.9272 34.5302Z",
				fill: "#005BBF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7942 33.2041L18.3688 34.3005L18.6602 34.3993L18.5247 34.7801H19.0682L18.9335 34.3993L19.2238 34.3005L18.7942 33.2041Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.3221 33.2041L19.8959 34.3005L20.1851 34.3993L20.0503 34.7801H20.5949L20.4579 34.3993L20.7501 34.3005L20.3221 33.2041Z",
				fill: "#C8B100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.5578 34.5171L19.1324 35.612L19.4212 35.7142L19.2869 36.0931H19.8322L19.6975 35.7142L19.9878 35.612L19.5556 34.5171",
				fill: "#C8B100"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8527_35995",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			fill: "white",
			transform: "translate(0 0.000976562)"
		})
	}) })]
});
export default SvgSpainFlag;
